import { variablesGlobales } from '../configs/variables';
import getInstanceAxios from './axiosInstance';

export class HttpRequest {


    static async sendPayloadFormsUflow(data = {}) {

        try {
            let axiosInstance = getInstanceAxios();
            const responseServer = await axiosInstance.post(`${variablesGlobales.urlServiceBackend}/api/v1/uflow/forms`, data);
            const jsonData = await responseServer.data;

            return {
                error: false,
                message: jsonData,
                date: new Date()
            };

        } catch (error) {
            return {
                error: true,
                message: error.response.data,
                date: new Date()
            }
        }
    }

    /* 
    Ruta para enviar forms a controlador de datacredito experian
    */
    static async sendPayloadFormsExperian(data = {}) {

        try {
            let axiosInstance = getInstanceAxios();
            const responseServer = await axiosInstance.post(`${variablesGlobales.urlServiceBackend}/api/v1/experian/postdata`, data);
            const jsonData = await responseServer.data;

            return {
                error: false,
                message: jsonData,
                date: new Date()
            };

        } catch (error) {
            return {
                error: true,
                message: error.response.data,
                date: new Date()
            }
        }
    }

    static async restrictionListUflow(data) {

        try {
            let axiosInstance = getInstanceAxios();
            const responseServer = await axiosInstance.post(`${variablesGlobales.urlServiceBackend}/api/v1/uflow/createRestrictionListUflow`, data);
            const jsonData = await responseServer.data;

            return {
                error: false,
                message: jsonData,
                date: new Date()
            };

        } catch (error) {
            return {
                error: true,
                message: error.response.data,
                date: new Date()
            }
        }
    }

    static async sendPayloadRegister(data = {}) {

        try {
            let axiosInstance = getInstanceAxios();
            const responseServer = await axiosInstance.post(`${variablesGlobales.urlServiceBackend}/api/v1/auth/register`, data);
            const jsonData = await responseServer.data;
            return {
                error: false,
                message: jsonData,
                date: new Date()
            };

        } catch (error) {

            return {
                error: true,
                message: error.response.data,
                date: new Date()
            }
        }
    }

    static async loginRequestSms(data = {}) {

        try {
            let axiosInstance = getInstanceAxios();
            const responseServer = await axiosInstance.post(`${variablesGlobales.urlServiceBackend}/api/v1/auth/login-sms`, data);
            const jsonData = await responseServer.data;

            return {
                error: false,
                message: jsonData,
                date: new Date()
            };

        } catch (error) {

            return {
                error: true,
                message: error.response.data,
                date: new Date(),
                code: error.code
            }
        }
    }

    static async loginRequestEmail(data = {}) {

        try {
            let axiosInstance = getInstanceAxios();
            const responseServer = await axiosInstance.post(`${variablesGlobales.urlServiceBackend}/api/v1/auth/login-email`, data);
            const jsonData = await responseServer.data;
            console.log(jsonData);

            return {
                error: false,
                message: jsonData,
                date: new Date()
            };

        } catch (error) {

            return {
                error: true,
                message: error.response.data,
                date: new Date(),
                code: error.code
            }
        }
    }

    static async validateToken(data = {}, medium = "") {

        try {
            let axiosInstance = getInstanceAxios();
            const responseServer = await axiosInstance.post(
                `${variablesGlobales.urlServiceBackend}/api/v1/auth/validate-token?medium=${medium}`,
                data
            );
            const jsonData = await responseServer.data;
            return {
                error: false,
                message: jsonData,
                date: new Date()
            };
        } catch (error) {

            return {
                error: true,
                message: error.response.data,
                date: new Date(),
                code: error.code,
                status: 500
            }
        }
    }

    static async validateTokenSession(data = {}) {

        try {
            let axiosInstance = getInstanceAxios();
            const responseServer = await axiosInstance.post(`${variablesGlobales.urlServiceBackend}/api/v1/auth/validate-token-session`, data);
            const { isValid, message } = await responseServer.data;
            return {
                error: false,
                message: message,
                isValid: isValid,
                date: new Date()
            };

        } catch (error) {
            return {
                error: true,
                message: error.response.data,
                date: new Date(),
                code: error.code,
                status: 500,
                isValid: false,
            }
        }
    }

    static async validateTokenSessionVisitor(data = {}) {

        try {
            let axiosInstance = getInstanceAxios();
            const responseServer = await axiosInstance.post(`${variablesGlobales.urlServiceBackend}/api/v1/auth/validate-token-session-visitor`, data);
            const jsonData = await responseServer.data;
            return {
                error: false,
                message: jsonData,
                date: new Date()
            };

        } catch (error) {
            return {
                error: true,
                message: error.response.data,
                date: new Date(),
                code: error.code,
                status: 500,
                isValid: false,
            }
        }
    }

    static async getCreditUser(documento) {
        try {
            let axiosInstance = getInstanceAxios();
            const responseServer = await axiosInstance.get(`${variablesGlobales.urlServiceBackend}/api/v1/uflow/buscar-credito/${documento}`);
            const jsonData = await responseServer.data;
            return {
                error: false,
                message: jsonData,
                date: new Date()
            };
        } catch (error) {
            return {
                error: true,
                message: error.response.data,
                date: new Date(),
                code: error.code,
                status: 500
            }
        }
    }


    static async getCreditById(id) {
        try {
            let axiosInstance = getInstanceAxios();
            const responseServer = await axiosInstance.get(`${variablesGlobales.urlServiceBackend}/api/v1/uflow/buscar-credito-byid/${id}`);
            const jsonData = await responseServer.data;
            return {
                error: false,
                message: jsonData,
                date: new Date()
            };
        } catch (error) {
            return {
                error: true,
                message: error.response.data,
                date: new Date(),
                code: error.code,
                status: 500
            }
        }
    }

    static async getCreditUserPendingSignature(documento) {

        try {
            let axiosInstance = getInstanceAxios();
            const responseServer = await axiosInstance.get(`${variablesGlobales.urlServiceBackend}/api/v1/uflow/pendiente-firma/${documento}`);
            const jsonData = await responseServer.data;


            return {
                error: false,
                message: jsonData,
                date: new Date()
            };

        } catch (error) {

            return {
                error: true,
                message: error.response.data,
                date: new Date(),
                code: error.code,
                status: 500
            }
        }
    }

    static async getAllCreditUser(documento) {
        try {
            let axiosInstance = getInstanceAxios();
            const responseServer = await axiosInstance.get(`${variablesGlobales.urlServiceBackend}/api/v1/uflow/buscar-creditos/${documento}`);
            const jsonData = await responseServer.data;
            return {
                error: false,
                message: jsonData,
                date: new Date()
            };
        } catch (error) {
            return {
                error: true,
                message: error.response.data,
                date: new Date(),
                code: error.code,
                status: 500
            }
        }
    }

    static async registrarFechaAceptacion(data = {}) {

        try {
            let axiosInstance = getInstanceAxios();
            const responseServer = await axiosInstance.post(`${variablesGlobales.urlServiceBackend}/api/v1/uflow/registrar-fecha-aceptacion`, data);
            const jsonData = await responseServer.data;

            return {
                error: false,
                message: jsonData,
                date: new Date()
            };

        } catch (error) {

            return {
                error: true,
                message: error.response.data,
                date: new Date(),
                code: error.code,
                status: 500
            }
        }
    }


    static async registrarInfoBasicaUflow(data = {}) {

        try {
            let axiosInstance = getInstanceAxios();
            const responseServer = await axiosInstance.post(`${variablesGlobales.urlServiceBackend}/api/v1/uflow/save-info-basic`, data);
            const jsonData = await responseServer.data;

            return {
                error: false,
                message: jsonData,
                date: new Date()
            };

        } catch (error) {

            return {
                error: true,
                message: error.response.data,
                date: new Date(),
                code: error.code,
                status: 500
            }
        }
    }

    static async registrarBalanceCredito(data = {}) {

        try {
            let axiosInstance = getInstanceAxios();
            const responseServer = await axiosInstance.post(`${variablesGlobales.urlServiceBackend}/api/v1/uflow/actualizar-balance`, data);
            const jsonData = await responseServer.data;

            return {
                error: false,
                message: jsonData,
                date: new Date()
            };

        } catch (error) {

            return {
                error: true,
                message: error.response.data,
                date: new Date(),
                code: error.code,
                status: 500
            }
        }
    }

    static async renovarCredito(data = {}) {

        try {
            let axiosInstance = getInstanceAxios();
            const responseServer = await axiosInstance.post(`${variablesGlobales.urlServiceBackend}/api/v1/experian/renovar-credito`, data);
            const jsonData = await responseServer.data;

            return {
                error: false,
                message: jsonData,
                date: new Date()
            };

        } catch (error) {

            return {
                error: true,
                message: error.response.data,
                date: new Date(),
                code: error.code,
                status: 500
            }
        }
    }

    static async registrarDiasEnMora(data = {}) {

        try {
            let axiosInstance = getInstanceAxios();
            const responseServer = await axiosInstance.post(`${variablesGlobales.urlServiceBackend}/api/v1/uflow/actualizar-dias-mora`, data);
            const jsonData = await responseServer.data;

            return {
                error: false,
                message: jsonData,
                date: new Date()
            };

        } catch (error) {

            return {
                error: true,
                message: error.response.data,
                date: new Date(),
                code: error.code,
                status: 500
            }
        }
    }

    static async aceptarPagare(data = {}) {

        try {
            let axiosInstance = getInstanceAxios();
            const responseServer = await axiosInstance.post(`${variablesGlobales.urlServiceBackend}/api/v1/firma/aceptar-pagare`, data);
            const jsonData = await responseServer.data;

            return {
                error: false,
                message: jsonData,
                date: new Date()
            };

        } catch (error) {

            return {
                error: true,
                message: error.response.data,
                date: new Date(),
                code: error.code,
                status: 500
            }
        }
    }

    static async firmarDocumentos(data = {}) {

        try {
            let axiosInstance = getInstanceAxios();
            const responseServer = await axiosInstance.post(`${variablesGlobales.urlServiceBackend}/api/v1/firma/firmar`, data);
            const jsonData = await responseServer.data;

            return {
                error: false,
                message: jsonData,
                date: new Date()
            };

        } catch (error) {

            return {
                error: true,
                message: error.response.data,
                date: new Date(),
                code: error.code,
                status: 500
            }
        }
    }

    static async getInfoUser(documento) {

        try {
            let axiosInstance = getInstanceAxios();
            const responseServer = await axiosInstance.get(`${variablesGlobales.urlServiceBackend}/api/v1/info/get-info/${documento}`);
            const jsonData = await responseServer.data;

            return {
                error: false,
                message: jsonData,
                date: new Date()
            };

        } catch (error) {

            return {
                error: true,
                message: error.response.data,
                date: new Date(),
                code: error.code,
                status: 500
            }
        }
    }

    static async getUserAuth(documento) {

        try {
            let axiosInstance = getInstanceAxios();
            const responseServer = await axiosInstance.get(`${variablesGlobales.urlServiceBackend}/api/v1/auth/findByDoc/${documento}`);
            const jsonData = await responseServer.data;

            return {
                error: false,
                message: jsonData,
                date: new Date()
            };

        } catch (error) {

            return {
                error: true,
                message: error.response.data,
                date: new Date(),
                code: error.code,
                status: 500
            }
        }
    }

    static async getQuotaStatus(documento) {

        try {
            let axiosInstance = getInstanceAxios();
            const responseServer = await axiosInstance.get(`${variablesGlobales.urlServiceBackend}/api/v1/uflow/info-cupo/${documento}`);
            const jsonData = await responseServer.data;


            return {
                error: false,
                message: jsonData,
                date: new Date()
            };

        } catch (error) {

            return {
                error: true,
                message: error.response.data,
                date: new Date(),
                code: error.code,
                status: 500
            }
        }
    }

    static async validateInfoBasicUser(documento) {

        try {
            let axiosInstance = getInstanceAxios();
            const responseServer = await axiosInstance.get(`${variablesGlobales.urlServiceBackend}/api/v1/info/validate-data-exist/${documento}`);
            const jsonData = await responseServer.data;
            return {
                error: false,
                message: jsonData,
                date: new Date()
            };
        } catch (error) {

            return {
                error: true,
                message: error.response.data,
                date: new Date(),
                code: error.code,
                status: 500
            }
        }
    }

    static async hasActiveCredit(documento) {

        try {
            let axiosInstance = getInstanceAxios();
            const responseServer = await axiosInstance.get(`${variablesGlobales.urlServiceBackend}/api/v1/uflow/hasActive/${documento}`);
            const jsonData = await responseServer.data;
            return {
                error: false,
                message: jsonData,
                date: new Date()
            };
        } catch (error) {

            return {
                error: true,
                message: error.response.data,
                date: new Date(),
                code: error.response.data,
                status: 500
            }
        }
    }

    static async importQuotas(data) {

        try {
            let axiosInstance = getInstanceAxios();
            const responseServer = await axiosInstance.post(`${variablesGlobales.urlServiceImports}/api/v1/import/quota/create`, data, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            const jsonData = await responseServer.data;

            return {
                error: false,
                message: jsonData,
                date: new Date()
            };

        } catch (error) {

            return {
                error: true,
                message: error.response.data,
                date: new Date(),
                code: error.code,
                status: 500
            }
        }
    }

    static async importPaymentsEfecty(data) {

        try {
            let axiosInstance = getInstanceAxios();
            const responseServer = await axiosInstance.post(`${variablesGlobales.urlServiceImports}/api/v1/import/payment/efecty/create`, data, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            const jsonData = await responseServer.data;

            return {
                error: false,
                message: jsonData,
                date: new Date()
            };

        } catch (error) {
            return {
                error: true,
                message: error.response.data,
                date: new Date(),
                code: error.code,
                status: 500
            }
        }
    }

    static async importDisbursements(data) {

        try {
            let axiosInstance = getInstanceAxios();
            const responseServer = await axiosInstance.post(`${variablesGlobales.urlServiceImports}/api/v1/import/disbursements/create`, data, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            const jsonData = await responseServer.data;

            return {
                error: false,
                message: jsonData,
                date: new Date()
            };

        } catch (error) {
            return {
                error: true,
                message: error.response.data,
                date: new Date(),
                code: error.code,
                status: 500
            }
        }
    }


    static async importPaymentsEfectyExtendCredit(data) {

        try {
            let axiosInstance = getInstanceAxios();
            const responseServer = await axiosInstance.post(`${variablesGlobales.urlServiceImports}/api/v1/import/payment/efecty/extend/create`, data, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            const jsonData = await responseServer.data;

            return {
                error: false,
                message: jsonData,
                date: new Date()
            };

        } catch (error) {

            return {
                error: true,
                message: error.response.data,
                date: new Date(),
                code: error.code,
                status: 500
            }
        }
    }



    static async importIncrementquota(data) {

        try {
            let axiosInstance = getInstanceAxios();
            const responseServer = await axiosInstance.post(`${variablesGlobales.urlServiceImports}/api/v1/import/quota/incrementquota/create`, data, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            const jsonData = await responseServer.data;

            return {
                error: false,
                message: jsonData,
                date: new Date()
            };

        } catch (error) {

            return {
                error: true,
                message: error.response.data,
                date: new Date(),
                code: error.code,
                status: 500
            }
        }
    }

    static async getInfoBiometria(documento) {

        try {
            let axiosInstance = getInstanceAxios();
            const responseServer = await axiosInstance.get(`${variablesGlobales.urlServiceBackend}/api/v1/biometria/getinfo/${documento}`);
            const jsonData = await responseServer.data;
            return {
                error: false,
                message: jsonData,
                date: new Date()
            };

        } catch (error) {

            return {
                error: true,
                message: error.response.data,
                date: new Date(),
                code: error.code,
                status: 500
            }
        }
    }

    static async createBiometria(data) {

        try {
            let axiosInstance = getInstanceAxios();
            const responseServer = await axiosInstance.post(`${variablesGlobales.urlServiceBackend}/api/v1/biometria/create`, data);
            const jsonData = await responseServer.data;
            return {
                error: false,
                message: jsonData,
                date: new Date()
            };

        } catch (error) {
            return {
                error: true,
                message: error.response.data,
                date: new Date(),
                code: error.code,
                status: 500
            }
        }
    }

    static async calcularDeuda(data) {
        try {
            let axiosInstance = getInstanceAxios();
            const responseServer = await axiosInstance.post(`${variablesGlobales.urlServiceBackend}/api/v1/utils/calculaDeuda`, data);
            const jsonData = await responseServer.data;
            return {
                error: false,
                message: jsonData,
                date: new Date()
            };

        } catch (error) {
            return {
                error: true,
                message: error.response.data,
                date: new Date(),
                code: error.code,
                status: 500
            }
        }
    }

    static async calcularDeudaV2(data) {
        try {
            let axiosInstance = getInstanceAxios();
            const responseServer = await axiosInstance.post(`${variablesGlobales.urlServiceBackend}/api/v1/utils/calculaDeudaV2`, data);
            const jsonData = await responseServer.data;
            return {
                error: false,
                message: jsonData,
                date: new Date()
            };

        } catch (error) {
            return {
                error: true,
                message: error.response.data,
                date: new Date(),
                code: error.code,
                status: 500
            }
        }
    }

    static async importApprovedList(data) {

        try {
            let axiosInstance = getInstanceAxios();
            const responseServer = await axiosInstance.post(`${variablesGlobales.urlServiceBackend}/api/v1/import/uflow/approvedListUpdate`, data, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            const jsonData = await responseServer.data;

            return {
                error: false,
                message: jsonData,
                date: new Date()
            };

        } catch (error) {

            return {
                error: true,
                message: error.response.data,
                date: new Date(),
                code: error.code,
                status: 500
            }
        }
    }

    static async getPercentLevel(documento) {

        try {
            let axiosInstance = getInstanceAxios();
            const responseServer = await axiosInstance.get(`${variablesGlobales.urlServiceBackend}/api/v1/utils/calcPercentLevel?doc=${documento}`);
            const jsonData = await responseServer.data;

            return {
                error: false,
                message: jsonData,
                date: new Date()
            };

        } catch (error) {

            return {
                error: true,
                message: error.response.data,
                date: new Date(),
                code: error.code,
                status: 500
            }
        }
    }

    static async getLastActivity(documento, limit=4) {

        try {
            let axiosInstance = getInstanceAxios();
            const responseServer = await axiosInstance.get(`${variablesGlobales.urlServiceBackend}/api/v1/lastActivity/getActivity?doc=${documento}&limit=${limit}`);
            const jsonData = await responseServer.data;

            return {
                error: false,
                message: jsonData,
                date: new Date()
            };

        } catch (error) {

            return {
                error: true,
                message: error.response.data,
                date: new Date(),
                code: error.code,
                status: 500
            }
        }
    }

    static async getDetermineRedirectForm(documento) {

        try {
            let axiosInstance = getInstanceAxios();
            const responseServer = await axiosInstance.get(`${variablesGlobales.urlServiceBackend}/api/v1/utils/determineRedirectForm?doc=${documento}`);
            const jsonData = await responseServer.data;

            return {
                error: false,
                message: jsonData,
                date: new Date()
            };

        } catch (error) {

            return {
                error: true,
                message: error.response.data,
                date: new Date(),
                code: error.code,
                status: 500
            }
        }
    }

    static async getTMLV() {

        try {
            let axiosInstance = getInstanceAxios();
            const responseServer = await axiosInstance.get(`${variablesGlobales.urlServiceBackend}/api/v1/tmlv/getinfo`);
            const jsonData = await responseServer.data;

            return {
                error: false,
                message: jsonData,
                date: new Date()
            };

        } catch (error) {

            return {
                error: true,
                message: error.response.data,
                date: new Date(),
                code: error.code,
                status: 500
            }
        }
    }

    static async updateTmlv(data) {
        try {
            let axiosInstance = getInstanceAxios();
            const responseServer = await axiosInstance.post(`${variablesGlobales.urlServiceBackend}/api/v1/tmlv/update`, data);
            const jsonData = await responseServer.data;
            return {
                error: false,
                message: jsonData,
                date: new Date()
            };

        } catch (error) {
            return {
                error: true,
                message: error.response.data,
                date: new Date(),
                code: error.code,
                status: 500
            }
        }
    }


    static async updateFeSiigo(data) {
        try {
            let axiosInstance = getInstanceAxios();
            const responseServer = await axiosInstance.post(`${variablesGlobales.urlServiceBackend}/api/v1/fesiigo/update`, data);
            const jsonData = await responseServer.data;
            return {
                error: false,
                message: jsonData,
                date: new Date()
            };

        } catch (error) {
            return {
                error: true,
                message: error.response.data,
                date: new Date(),
                code: error.code,
                status: 500
            }
        }
    }

    static async getFeSiigo() {
        try {
            let axiosInstance = getInstanceAxios();
            const responseServer = await axiosInstance.get(`${variablesGlobales.urlServiceBackend}/api/v1/fesiigo/getinfo`);
            const jsonData = await responseServer.data;
            return {
                error: false,
                message: jsonData,
                date: new Date()
            };

        } catch (error) {
            return {
                error: true,
                message: error.response.data,
                date: new Date(),
                code: error.code,
                status: 500
            }
        }
    }


    static async reporteAcierta(data) {
        try {
            let axiosInstance = getInstanceAxios();
            const responseServer = await axiosInstance.post(`${variablesGlobales.urlServiceImports}/api/v1/utils/reporte/acierta`, data);
            const jsonData = await responseServer.data;
            return {
                error: false,
                message: jsonData,
                date: new Date()
            };

        } catch (error) {
            return {
                error: true,
                message: error.response.data,
                date: new Date(),
                code: error.code,
                status: 500
            }
        }
    }

    static async reporteReconocer(data) {
        try {
            let axiosInstance = getInstanceAxios();
            const responseServer = await axiosInstance.post(`${variablesGlobales.urlServiceImports}/api/v1/utils/reporte/reconocer`, data);
            const jsonData = await responseServer.data;
            return {
                error: false,
                message: jsonData,
                date: new Date()
            };

        } catch (error) {
            return {
                error: true,
                message: error.response.data,
                date: new Date(),
                code: error.code,
                status: 500
            }
        }
    }

    static async reportePoliticasMotor(data) {
        try {
            let axiosInstance = getInstanceAxios();
            const responseServer = await axiosInstance.post(`${variablesGlobales.urlServiceImports}/api/v1/utils/reporte/politicas`, data);
            const jsonData = await responseServer.data;
            return {
                error: false,
                message: jsonData,
                date: new Date()
            };

        } catch (error) {
            return {
                error: true,
                message: error.response.data,
                date: new Date(),
                code: error.code,
                status: 500
            }
        }
    }

    static async getInfoRole(doc = "") {

        try {
            let axiosInstance = getInstanceAxios();
            const responseServer = await axiosInstance.get(`${variablesGlobales.urlServiceBackend}/api/v1/auth/getrole?doc=${doc}`);
            const jsonData = await responseServer.data;

            return {
                error: false,
                message: jsonData,
                date: new Date()
            };

        } catch (error) {

            return {
                error: true,
                message: error.response.data,
                date: new Date(),
                code: error.code,
                status: 500
            }
        }
    }

    static async generateContract(data) {
        try {
            let axiosInstance = getInstanceAxios();
            const responseServer = await axiosInstance.post(`${variablesGlobales.urlServiceBackend}/api/v1/utils/generate/contract`, data);
            const jsonData = await responseServer.data;
            return {
                error: false,
                message: jsonData,
                date: new Date()
            };

        } catch (error) {
            return {
                error: true,
                message: error.response.data,
                date: new Date(),
                code: error.code,
                status: 500
            }
        }
    }
}